import React from 'react';
import Select from 'react-select';
import { Product } from '../../types/Product';
import { sweetalert } from '../../App';
import { isBlank, isOnlyWhitespace } from '../../util/ValidationUtil';
import { buildRow, getBoolSelectOptions, getBoolSelectVal, getLabel } from '../../util/FormatUtil';
import { isEmptyObject } from 'jquery';
import GetField from '../../customfields/GetField';
import { CustomFieldBuilder } from '../../customfields/CustomFieldBuilder';

interface ProductManagementState {
  selectedProduct: Product;
  customFieldData?;
}
interface ProductManagementProps {
  selectedProduct;
  onSubmit?;
  pageCustomQuestions?;
  services?;
}
export default class ProductManagementModal extends React.Component<ProductManagementProps, ProductManagementState> {
  public static ID = 'productmanagement';
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: {
        ID: null,
        Name: null,
        Price: null,
        Description: null,
        Units: null,
        IsHomeKit: false,
        ServiceID: null,
      } as Product,
    } as ProductManagementState;
  }

  componentDidMount(): void {
    $(`#${ProductManagementModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
  }

  componentWillReceiveProps(nextProps: Readonly<ProductManagementProps>, nextContext: any) {
    if (!isEmptyObject(nextProps.selectedProduct)) {
      let product = nextProps.selectedProduct;
      this.setState({
        selectedProduct: {
          ID: product.ID,
          Name: product.Name,
          Price: product.Price,
          Description: product.Description,
          Units: product.Units,
          IsHomeKit: product.IsHomeKit,
          ServiceID: product.ServiceID,
        } as Product,
      });
    }
  }

  render() {
    return (
      <div
        className="modal fade form_modal"
        id={ProductManagementModal.ID}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="result_modal_label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="result_modal_label">
                  Product Management
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {buildRow(
                  'Product',
                  <input
                    className={'form-control'}
                    id="Product"
                    maxLength={50}
                    readOnly={this.state.selectedProduct.ID != null}
                    autoComplete={'off'}
                    type={'search'}
                    name={'Product'}
                    aria-label="Product"
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedProduct: {
                          ...prevState.selectedProduct,
                          Name: e.target.value,
                        },
                      }));
                    }}
                    value={this.state.selectedProduct.Name}
                  />
                )}

                {buildRow(
                  'Description',
                  <input
                    className={'form-control'}
                    id="Description"
                    maxLength={50}
                    autoComplete={'off'}
                    type={'search'}
                    name={'Description'}
                    aria-label="Description"
                    onChange={(e) =>
                      this.setState((prevState) => ({
                        selectedProduct: {
                          ...prevState.selectedProduct,
                          Description: e.target.value,
                        },
                      }))
                    }
                    value={this.state.selectedProduct.Description}
                  />
                )}
                {buildRow(
                  'Price',
                  <input
                    className={'form-control'}
                    id="Price"
                    min={0}
                    type={'number'}
                    name={'Price'}
                    aria-label="Price"
                    onChange={(e) =>
                      this.setState((prevState) => ({
                        selectedProduct: {
                          ...prevState.selectedProduct,
                          Price: Number(e.target.value),
                        },
                      }))
                    }
                    value={this.state.selectedProduct.Price}
                  />
                )}
                {buildRow(
                  'Units',
                  <input
                    className={'form-control'}
                    id="Units"
                    maxLength={50}
                    autoComplete={'off'}
                    type={'search'}
                    name={'Units'}
                    aria-label="Units"
                    onChange={(e) =>
                      this.setState((prevState) => ({
                        selectedProduct: {
                          ...prevState.selectedProduct,
                          Units: e.target.value,
                        },
                      }))
                    }
                    value={this.state.selectedProduct.Units}
                  />
                )}

                {buildRow(
                  'Is Home Kit?',
                  <Select
                    isSearchable={true}
                    placeholder={<div className="accessibilityText">Please Select...</div>}
                    noOptionsMessage={() => 'No option'}
                    aria-label="Regitered?"
                    value={getBoolSelectVal(this.state.selectedProduct.IsHomeKit)}
                    onChange={(e) =>
                      this.setState((prevState) => ({
                        selectedProduct: {
                          ...prevState.selectedProduct,
                          IsHomeKit: e.value ? 1 : 0,
                          ServiceID: null
                        },
                      }))
                    }
                    className={'state_select'}
                    options={getBoolSelectOptions()}
                  />
                )}

                {this.state.selectedProduct && this.state.selectedProduct.IsHomeKit ? (
                  buildRow(
                    'Service',
                    <Select
                      isSearchable={true}
                      placeholder={'Please Select...'}
                      noOptionsMessage={() => 'No option'}
                      aria-label="Service"
                      value={getLabel(
                        this.state.selectedProduct.ServiceID,
                        this.props.services.map((k) => ({ label: k.Name, value: k.ID }))
                      )}
                      onChange={(e) =>
                        this.setState((prevState) => ({
                          selectedProduct: {
                            ...prevState.selectedProduct,
                            ServiceID: e.value,
                          },
                        }))
                      }
                      className={'state_select'}
                      options={this.props.services.map((k) => ({ label: k.Name, value: k.ID }))}
                    />
                  )
                ) : null}

                {/* {
                                (this.props.pageCustomQuestions)
                                    ?
                                    <div className="row">
                                        {this.props.pageCustomQuestions.map((val, index) => {
                                            if(val.Options.isActive){
                                                return (
                                                    <div className="col-12">
                                                        <div className="form-group row">
                                                            <GetField 
                                                            val={val} 
                                                            selectedItem={this.state.selectedProduct ? this.state.selectedProduct : null} 
                                                            handleChange={(e) => {
                                                                this.setState({selectedProduct: e})
                                                            }}  
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } 
                                            else {
                                                return <></>
                                            }
                                        })}
                                    </div>
                                    :
                                    <div className="invisible"></div>
                            } */}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    if (isBlank(this.state.selectedProduct.Name) || isOnlyWhitespace(this.state.selectedProduct.Name)) {
                      return sweetalert.fire('', 'Product cannot be empty.', 'error');
                    }
                    if (
                      isBlank(this.state.selectedProduct.Description) ||
                      isOnlyWhitespace(this.state.selectedProduct.Description)
                    ) {
                      return sweetalert.fire('', 'Description cannot be empty', 'error');
                    }
                    if (
                      !this.state.selectedProduct.Price ||
                      isNaN(this.state.selectedProduct.Price) ||
                      this.state.selectedProduct.Price < 0
                    ) {
                      return sweetalert.fire('', 'Price must be a positive number', 'error');
                    }
                    if (
                      isBlank(this.state.selectedProduct.Units) ||
                      isOnlyWhitespace(this.state.selectedProduct.Units)
                    ) {
                      return sweetalert.fire('', 'Units cannot be empty.', 'error');
                    }

                    if (this.state.selectedProduct.IsHomeKit && !this.state.selectedProduct.ServiceID) {
                      return sweetalert.fire('', 'Service is required for Home Kit products.', 'error');
                    }

                    // let invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedProduct.CustomFieldData, this.props.pageCustomQuestions, this.state.selectedProduct)

                    // if(invalid){
                    //     return;
                    // }

                    this.props.onSubmit(this.state.selectedProduct);
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
